import React, {useState} from "react";
import Main from "../../Component/Main-body/Main";
import Navbar from "../../Component/Navbar/Navbar";

import Sidebar from "../../Component/Sidebar/SIdebar";


import "./Home.css";
const Home = () => {
  const [isActive, setActive] = useState(false);
  const [main, setMain] = useState(1);
  const toggleMain = (index) =>{
    setMain(index)
  }
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <div className="App">
      <div className="side-bar ">
    <Sidebar handleToggle={toggleClass}isActive={isActive} handleMain={toggleMain} main={main} />
      </div>
      <div className="main w-100">
        <Navbar isActive={isActive} />
        <Main main={main}/>
      </div>
    </div>
  );
};

export default Home;
